import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "splash-screen-acknowledgements",
  class: "splash-screen-small"
}
const _hoisted_2 = { id: "splash-screen-logos" }

export interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  cssVars?: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SplashScreen',
  props: /*@__PURE__*/_mergeModels({
    cssVars: { default: () => ({}) }
  }, {
    "modelValue": {default: true},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(['close'], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const showSplashScreen = _useModel(__props, "modelValue");


function closeSplashScreen() {
  showSplashScreen.value = false;
  emits('close');
}



return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_credit_logos = _resolveComponent("credit-logos")!
  const _component_focus_trap = _resolveComponent("focus-trap")!
  const _component_v_overlay = _resolveComponent("v-overlay")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_component_v_overlay, {
    "model-value": showSplashScreen.value,
    absolute: "",
    opacity: "0.6",
    style: _normalizeStyle(props.cssVars),
    id: "splash-overlay"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_focus_trap, null, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createElementBlock("div", {
            id: "splash-screen",
            style: _normalizeStyle(props.cssVars)
          }, [
            _createVNode(_component_font_awesome_icon, {
              id: "close-splash-button",
              class: "tab-focusable",
              icon: "xmark",
              onClick: closeSplashScreen,
              onKeyup: _withKeys(closeSplashScreen, ["enter"]),
              tabindex: "0"
            }),
            _cache[2] || (_cache[2] = _createElementVNode("div", { id: "splash-screen-text" }, [
              _createElementVNode("div", { class: "highlight" }, "Blaze Star Nova"),
              _createElementVNode("div", { class: "burst" }, "Learn where in the sky to watch for a \"new\" star!")
            ], -1)),
            _createElementVNode("div", _hoisted_1, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { id: "links" }, [
                _createTextVNode(" This Data Story is brought to you by "),
                _createElementVNode("a", {
                  href: "https://www.cosmicds.cfa.harvard.edu/",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  class: "no-wrap"
                }, "Cosmic Data Stories"),
                _createTextVNode(" and "),
                _createElementVNode("a", {
                  href: "https://www.worldwidetelescope.org/home/",
                  target: "_blank",
                  rel: "noopener noreferrer",
                  class: "no-wrap"
                }, "WorldWide Telescope"),
                _createTextVNode(". ")
              ], -1)),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_credit_logos, {
                  "default-logos": ['cosmicds', 'wwt', 'sciact', 'nasa'],
                  "logo-size": "4vmax"
                })
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("div", { id: "image-credit" }, " Image credit: NASA / Goddard Space Flight Center ", -1))
            ])
          ], 4)), [
            [_directive_click_outside, closeSplashScreen]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value", "style"]))
}
}

})